<template>
	<div class="w-full text-center">
		<div class="heading-1 mb-2">
			{{ languageData.popularBusinessTrips }}
		</div>

		<div class="display-1 mb-8">
			{{ languageData.roundTripFrom }} {{ destination }}
		</div>

		<div class="mx-auto max-w-[1136px] flex p-4 bg-grey-1 rounded-[48px] justify-center items-center gap-4 flex-wrap content-center">
			<div
				v-for="(flight, index) in flights"
				:key="index"
				class="hover:cursor-pointer flex-1 min-w-[250px] p-4 bg-white rounded-[32px] border-grey-3 inline-flex flex-col justify-start items-start gap-3"
				@click="navigateToSearch(flight)"
			>
				<div class="self-stretch flex flex-col justify-start items-center">
					<div class="heading-2">
						{{ flight.destination }}
					</div>
					<div class="self-stretch inline-flex justify-center items-center gap-1">
						<div class="body-2">
							Roundtrip
						</div>
						<div class="body-2">
							•
						</div>
						<div class="body-2">
							{{ flight.dateRange }}
						</div>
					</div>
				</div>


				<div class="self-stretch rounded-tl-lg rounded-tr-lg rounded-bl-2xl rounded-br-2xl flex flex-col justify-start items-start gap-1 overflow-hidden">
					<div class="self-stretch pr-3 py-2 bg-gray-50 inline-flex justify-start items-start gap-3">
						<div class="w-1.5 self-stretch bg-red-action rounded-tr rounded-br" />
						<div class="flex-1 inline-flex flex-col justify-start items-start">
							<div class="body-1 body-1-bold">
								{{ flight.airline }}
							</div>
							<div class="body-2">
								{{ flight.fareClass }}
							</div>
						</div>
						<div class="inline-flex flex-col justify-start items-end">
							<div class="body-1 body-1-bold">
								{{ formatPrice(flight.price) }}
							</div>
							<div class="body-2">
								{{ flight.currency }}
							</div>
						</div>
					</div>

					<!-- Points -->
					<div class="self-stretch px-3 py-1 bg-red-100 inline-flex justify-center items-center gap-1 overflow-hidden">
						<div class="py-0.5 inline-flex flex-col justify-start items-start">
							<div class="justify-center">
								<span class="body-2 body-2-medium !text-red-action">{{ languageData.earn }} </span>
								<span class="body-2-bold body-2 !text-red-action"> {{ formatPrice(flight.pointsValue, 0) }} {{ flight.currency }} </span>
								<span class="body-2 body-2-medium !text-red-action"> {{ languageData.inJauntrRewards }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script src="./atm-featured.js" />
<style lang="scss" src="./atm-featured.scss"></style>